<template src="./templates/item.html" />
<script type="text/ecmascript-6">
import AnimationProcessing from 'components/animations/processing'
import { mapGetters } from 'vuex'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'

export default {
  name: 'GraphicItem',

  data() {
    return {
      isDeleted: false
    }
  },

  components: {
    AnimationProcessing
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [String,Number],
      required: true
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('graphics', {
      graphicsStates: ['states']
    }),
    pictureStyle () {
      const versions = this.item.image.versions
      let src = ''
      function _getSrc (format) {
        const version = versions.filter(v => v.versionType === format)[0] || {}
        return typeof version.resourceLocation === 'string' ? version.resourceLocation : ''
      }
      if (versions) {
        src = _getSrc('thumbnail')
      }
      return {
        background: 'url(' + src + ') center center / cover no-repeat'
      }
    }
  },

  methods: {
    isUploading () {
      return this.item.status === this.graphicsStates.UPLOADED
    },
    isComplete () {
      return this.item.status === this.graphicsStates.COMPLETE
    },
    remove () {
      return this.$store.dispatch('graphics/delete', {
        imageId: this.item.image.id,
        submissionId: this.submission.id
      })
    }
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
